/**
 * Pulls the users cart from the backend.  This includes items, prices,
 * and client_logos found in the cart, allowing a users cart to persist
 * cross-device.
 *
 * If a coupon is detected after the cart loads, we'll also apply that to the cart.
 */
export default async ({ store, query, $sentry }) => {
  let coupon = query.coupon

  store.dispatch('cart/fetchCart').then(() => {
    if (coupon) {
      // Handle applying the coupon to the cart now.
      try {
        store.dispatch('cart/applyCoupon', coupon)
      } catch (error) {
        $sentry.captureException(error)
      }
    }
  })
}
